import { AUFTRAG_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { stagingStatusColumn, useLoadStagingObjects } from '@Hooks/Staging/index';
import { EnumStagingStatus } from '@Model';
import { EnumFilterExpressionOperation, EnumOperation } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useFeatureFlags } from '@Contexts/featureFlags';
import { useListApi } from '@Hooks/useListApi';
import { OrdersRepository } from '@Repositories/Auftragsbearbeitung';

const filterPayload = {
    page_no: 0,
    sort_columns: [],
    full_text_search: '',
    page_size: 0,
    filter_columns: {
        operation: EnumFilterExpressionOperation.Or,
        filters: [
            {
                field: stagingStatusColumn,
                value: EnumStagingStatus.New.toString(),
                operator: EnumOperation.Equal,
            },
            {
                field: stagingStatusColumn,
                value: EnumStagingStatus.Seen.toString(),
                operator: EnumOperation.Equal,
            },
        ],
    },
};

export function useStagedOrdersCountQuery() {
    const hasPermission = useHasPermission();
    const { isFeatureEnabled } = useFeatureFlags();

    const { loadPage } = useListApi(OrdersRepository, AUFTRAG_API);

    const loadStagedOrders = useLoadStagingObjects(loadPage);

    const { data, isLoading, isSuccess, isError, error } = useQuery({
        queryKey: ['orders', 'count'],
        queryFn: () => loadStagedOrders(filterPayload),
        enabled: isFeatureEnabled('STAGING') && hasPermission(Permission.AuftragsbearbeitungOrdersRead),
    });

    return {
        count: data?.total_item_count ?? 0,
        isLoading,
        isSuccess,
        isError,
        error,
    };
}
